import { UserToolSet } from "@cohesive/api-client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { orgAPI } from "./api";

/**
 * The user's connected tool sets. Used to resolve which connector(s) a proposed
 * terminal command touches, by matching each tool set's `cli_name` against the
 * command. Cached for a few minutes — the connected set rarely changes within a
 * chat, and many tool-call cards read from it.
 */
export function useConnectedToolSets(
  options?: Partial<UseQueryOptions<UserToolSet[], AxiosError>>,
) {
  return useQuery<UserToolSet[], AxiosError>({
    queryKey: ["connectedToolSets"],
    queryFn: async () => {
      const res = await orgAPI.toolSets.userList({
        connected: true,
        limit: 10000,
      });
      return res.data.tool_sets;
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
